import useClipboard from 'vue-clipboard3'
import { showToast } from '@nio-fe/horo-h5'
const { toClipboard } = useClipboard()

export const copyValue = async (text: string, successToast?: string, failToast?: string) => {
  toClipboard(text).then(
    () =>
      showToast({
        content: successToast || '复制成功',
        type: 'success',
      }),
    () => {
      showToast({
        content: failToast || '复制失败',
        type: 'failure',
      })
    }
  )
}
